module.exports = __webpack_public_path__ + "img/jiangbei.d252af05.png";